import Component from "../reason/pages/numbers/NumbersPage.bs"
export default Component
